import React from "react";
import {request} from "../../../api-client";
import localization from "../../../config/localization";
import { pushIfDoesNotExist } from "../../../utils";
import './HomePlaylist.css'
import {ArrowBack, Description, Headset, Image, PlayCircleFilled, Share} from "@material-ui/icons";
import {Link} from "react-router-dom";
import { homePathGenerator, setPageTitle, slugify } from "../../../api-client/core/authentication/utils";
import styled from "styled-components";
import Slider from "react-slick";
import PrevArrow from "../../../components/Letflow/Arrows/PrevArrow";
import NextArrow from "../../../components/Letflow/Arrows/NextArrow";
import PlaylistCreationItem from "../../../components/Letflow/PlaylistCreationItem";
import ContentCreationPlayer from "../../../components/Letflow/ContentCreationPlayer";
import ContentCreatorItem from "../../../components/Letflow/ContentCreatorItem";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../../../components/Letflow/Snackbar/GlobalSnackbar";
import {IconButton, Tooltip} from "@material-ui/core";
import ShareOnSocials from "../../../components/Letflow/ShareOnSocials";

const availableFileTypes =
  [
    {id: "video", icon: <PlayCircleFilled style={{color: "#727272"}} />},
    {id: "audio", icon: <Headset style={{color: "#727272"}} />},
    {id: "binary", icon: <Description style={{color: "#727272"}} />},
    {id: "image", icon: <Image style={{color: "#727272"}} />},
  ]

class Playlist extends React.Component {
  state = {
    playlist: undefined,
    loading: true,
    loadingFailed: false,
    tags: [],
    musics: [],
    selectedTags: [],
    showContentCreationDialog: false,
    currentPlayingContent: {},
    currentPlayingList: [],
    showShareDialog: false,
    shareLink: "",
    shareToken: "",
    failedLink: false,
  };

  componentDidMount = () => {
    this.requestData()
    document.getElementsByTagName('html')[0].scrollTop = 0
  };

  requestData = () => {
    this.setState({loading: true})
    if(!this.props.isPublic) {
      const {playlistId} = this.props.match.params
      return request.playlist.get(playlistId, `include=image;tags;contentCreations.favorite;contentCreations.video.thumbnail;contentCreations.binary;contentCreations.image;contentCreations.embededContent;contentCreations.contentCreator.image;contentCreations.audio.waveform;contentCreations.tags`)
        .then(playlist => this.setState({playlist, loading: false}))
        .then(() => setPageTitle(this.state.playlist.title))
    } else {
      return  request.public.playlist(this.props.token)
        .then(playlist => this.setState({playlist, loading: false}))
        .then(() => setPageTitle(this.state.playlist.title))
        .catch(() => this.setState({failedLink: true}));
    }
  }

  onFavorite = (creation) => {
    if(!creation.favorite) {
      this.addToFavorites(creation.id)
    } else  {
      this.removeFromFavorites(creation.id)
    }
  }

  addToFavorites = id => {
    this.setState(state => ({
      ...state,
      playlist: {
        ...state.playlist,
        contentCreations: state.playlist.contentCreations.map(creation => {
          if (creation.id === id) {
            return ({...creation, favorite: true})
          }
          return creation
        }),
        contentCreators: !state.playlist.contentCreators ? [] : state.playlist.contentCreators.map(creator => {
          return ({...creator, contentCreations: creator.contentCreations.map(creation => {
              if (creation.id === id) {
                return ({...creation, favorite: true})
              }
              return creation
            })
          })
        })
      }
    }))

    request.contentCreationFavorite.add(id)
  }

  removeFromFavorites = id => {
    this.setState(state => ({
      ...state,
      playlist: {...state.playlist,
        contentCreations: state.playlist.contentCreations.map(creation => {
          if (creation.id === id) {
            return ({...creation, favorite: false})
          }
          return creation
        }),
        contentCreators: !state.playlist.contentCreators ? [] : state.playlist.contentCreators.map(creator => {
          return ({...creator, contentCreations: creator.contentCreations.map(creation => {
              if (creation.id === id) {
                return ({...creation, favorite: false})
              }
              return creation
            })
          })
        })
    }}))

    request.contentCreationFavorite.remove(id)
  }

  onShareCreator = (creator) => request.contentCreator.share(creator.id)
    .then(response => this.setState({
      showShareDialog: true,
      shareLink: `${window.location.protocol}//${window.location.hostname}/public/content_creators/${response.code}`,
      shareToken: response.code
    }))

  onFavoriteCreator = (creator) => {
    if(!creator.favorite) {
      this.addToFavoritesCreator(creator.id)
    } else  {
      this.removeFromFavoritesCreator(creator.id)
    }
  }

  addToFavoritesCreator = id => {
    this.setState(state => ({
      ...state,
      playlist: {...state.playlist, contentCreators: state.playlist.contentCreators.map(creator => {
        if (creator.id === id) {
          return ({...creator, favorite: true})
        }
        return creator
      })
    }}))
    request.contentCreatorFavorite.add(id)
  }

  removeFromFavoritesCreator = id => {
    this.setState(state => ({
      ...state,
      playlist: {...state.playlist, contentCreators: state.playlist.contentCreators.map(creator => {
        if (creator.id === id) {
          return ({...creator, favorite: false})
        }
        return creator
      })
    }}))

    request.contentCreatorFavorite.remove(id)
  }


  updateTags = (tags, selectedTags) => {
    return tags.map(tag => ({
      ...tag,
      state: selectedTags.find(selectedTag => selectedTag.toString() === tag.id.toString()) ? 'selected' : 'available'
    }))
  };

  removeTagFromContentCreator = (type, contentCreatorId, tagId) => {
    request[type].removeTagFromPlaylist(this.props.match.params.playlistId, contentCreatorId, tagId)
      .then(() => this.requestData())
  };

  onSelectedTagsChanged = selectedTags => {
    this.setState({ selectedTags, tags: this.updateTags(this.state.tags, selectedTags) })
  };

  deleteFromPlaylist = (id, content) =>
    request.playlist.removeFromPlaylist({
      playlistId: this.state.playlist.id,
      musicId: id,
      type: content
    })
      .then(() => {
        GlobalSnackbar.show({
          message: localization.get(content === "contentCreators" ? "playlist.deleted_profile" : "playlist.deleted_content"),
          type: GlobalSnackbarTypes.SUCCESS,
          place: "bc"
        })
        if(content === "contentCreators") {
          const filteredContentCreators = this.state.playlist.contentCreators.filter(newContentCreators => id !== newContentCreators.id)
          this.setState(prevState => ({playlist: {...prevState.playlist, contentCreators: filteredContentCreators}}))
        }else {
          const filteredContentCreations = this.state.playlist.contentCreations.filter(newContentCreations => id !== newContentCreations.id)
          this.setState( prevState => ({playlist: {...prevState.playlist, contentCreations: filteredContentCreations}}))
        }
      })
      .catch(err => {
        console.error(err)
        GlobalSnackbar.show({
          message: localization.get("playlist.deleted_error"),
          type: GlobalSnackbarTypes.ERROR,
          place: "bc"
        })
      })

  clearCurrentPlayingContent = () => {
    this.setState({showContentCreationDialog: false, hasPrev: false, hasNext: false, currentIndex: null, currentPlayingContent: {}, currentPlayingList: []})
  }

  setCurrentPlayingContent = (index) => {
    if (!this.state.currentPlayingList || this.state.currentPlayingList.length < 1) {
      return;
    }
    let hasPrev = index > 0 ;
    let hasNext = index < (this.state.currentPlayingList.length - 1);
    this.setState({showContentCreationDialog: true, currentPlayingContent: this.state.currentPlayingList[index], hasPrev: hasPrev, hasNext: hasNext, currentIndex: index})
  }

  renderContentCreatorView = () => {
    const {playlist} = this.state
    const sliderSettings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      initialSlide: 0,
      centerMode: false,
      prevArrow: <PrevArrow overrideStyle={{transform: window.innerWidth > 800 ? "translate(20px, -40%)" : window.innerWidth > 600 ? "translate(15px, -40%)" : "translate(-10px, -40%)"}}/>,
      nextArrow: <NextArrow overrideStyle={{transform: window.innerWidth > 800 ? "translate(-8px, -40%)" : window.innerWidth > 600 ? "translate(-10px, -40%)" :"translate(10px, -40%)"}}/>,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false
          }
        }
      ]
    }
    const contentCreatorTypes = []
    playlist.contentCreators && playlist.contentCreators.length && playlist.contentCreators.forEach(contentCreator => pushIfDoesNotExist(contentCreatorTypes, contentCreator.type))

    return (
      <React.Fragment>
        <div className="playlist-title">
          {playlist.title}
          {!this.props.isPublic &&
            <IconButton
              style={{height: 30,marginLeft: 10,top: -3,width: 30}}
              onClick={() =>
                request.playlist.share(playlist.id)
                  .then(response => this.setState({
                    showShareDialog: true,
                    shareLink: `${window.location.protocol}//${window.location.hostname}/public/playlists/${response.code}`,
                    shareToken: response.code
                }))
              }
            >
              <Tooltip placement="top" title={localization.get("share")} >
                <Share style={{fontSize: 16}}/>
              </Tooltip>
            </IconButton>
          }
        </div>
        {contentCreatorTypes.map(contentCreatorType =>
          <React.Fragment>
            <h3 className="content-creator-title">{contentCreatorType.name}</h3>
            {playlist.contentCreators.filter(contentCreator => contentCreator.type.id === contentCreatorType.id)
              .sort((a, b) => a.country && b.country && a.country.key.localeCompare(b.country.key)).map(contentCreator => {
              let tags = [];
              contentCreator.contentCreations.forEach(contentCreation => {
                if (contentCreation.tags) contentCreation.tags.forEach(tag => pushIfDoesNotExist(tags, tag))
              })
              return (
                <React.Fragment>
                  <RespD>
                    {window.innerWidth > 767 ?
                      <div style={{width: 200, height: 200, position: "relative", float: "left", marginTop: 10}}>
                        <ContentCreatorItem
                          isPublic={this.props.isPublic}
                          contentCreator={contentCreator}
                          onFavorite={() => this.onFavoriteCreator(contentCreator)}
                          onShare={() => this.onShareCreator(contentCreator)}
                          onDelete={() => this.deleteFromPlaylist(contentCreator.id, 'contentCreators')}
                        />
                      </div>
                      :
                      <div style={{width: "100%", position: "relative", float: "left", marginTop: 10}}>
                        <Link
                          style={{color: "black"}}
                          to={homePathGenerator(this.props.isPublic ? `bl/${contentCreator.profile_url ? contentCreator.profile_url : contentCreator.hashcode}` : `contenido/${contentCreator.id}-${slugify(contentCreator.name)}`)}
                        >
                          <h3>{contentCreator.name}</h3>
                        </Link>
                      </div>
                    }

                    <div className="content-creator-content-container" >
                      <Slider
                        style={{width: "100%", position: "relative",  float: "left", backgroundColor:"#ccc", borderRadius: 10}}
                        {...sliderSettings}>
                        {contentCreator.contentCreations.map((item, key) =>
                          <PlaylistCreationItem
                            creation={item}
                            creator={contentCreator}
                            onFavorite={this.onFavorite}
                            onClick={() => this.setState({currentPlayingList: contentCreator.contentCreations}, () => this.setCurrentPlayingContent(key))}
                            // onClick={() => this.setState({showContentCreationDialog: true,currentPlayingContent: item})}
                            isPublic={this.props.isPublic}
                            onShare={e => {
                              e.preventDefault();
                              e.stopPropagation();

                              return request.contentCreation.share(item.id)
                                .then(response => this.setState({
                                  showShareDialog: true,
                                  shareLink: `${window.location.protocol}//${window.location.hostname}/public/content_creations/${response.code}`,
                                  shareToken: response.code
                                }))
                            }}
                          />)
                        }
                      </Slider>
                    </div>
                  </RespD>
                </React.Fragment>
              )
            })}
          </React.Fragment>
        )}
        <React.Fragment>
          {availableFileTypes.map((type, key) => {
            let creations = []
            if (type.id === "binary") creations = playlist.contentCreations.filter(creation => creation.binary )
            if (type.id === "video")  creations = playlist.contentCreations.filter(creation => creation.video || (creation.embededContent && creation.embededContent.source !== "spotify"))
            if (type.id === "audio")  creations = playlist.contentCreations.filter(creation => creation.audio || (creation.embededContent && creation.embededContent.source === "spotify"))
            if (type.id === "image")  creations = playlist.contentCreations.filter(creation => creation.image && !creation.embededContent && !creation.audio && !creation.video && !creation.binary)

            if (creations.length === 0) return null
            return (
              <>
                {key === 0 && <h3 className="content-creator-title">{localization.get('playlist.content_creations')}</h3>}
                <React.Fragment>
                  <RespD>
                    <div className="content-creator-container">
                      <div className="playlist-creation-icon">
                        {type.icon}
                      </div>
                      <div className="content-creator-content-container"  style={{width: "calc(100% - 90px)"}}>
                        <Slider
                          style={{width: "100%", position: "relative",  float: "left", backgroundColor:"#ccc", borderRadius: 10}}
                          {...sliderSettings}
                        >
                          {creations.map((item, key) =>
                            <PlaylistCreationItem
                              creation={item}
                              creator={item.contentCreator}
                              onClick={() => this.setState({currentPlayingList: creations}, () => this.setCurrentPlayingContent(key))}
                              // onClick={() => this.setState({showContentCreationDialog: true,currentPlayingContent: item})}
                              onFavorite={this.onFavorite}
                              isPublic={this.props.isPublic}
                              onDelete={() => this.deleteFromPlaylist(item.id, 'contentCreations')}
                              onShare={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                return request.contentCreation.share(item.id)
                                  .then(response => this.setState({
                                    showShareDialog: true,
                                    shareLink: `${window.location.protocol}//${window.location.hostname}/public/content_creations/${response.code}`,
                                    shareToken: response.code
                                  }))
                              }}
                            />
                          )}
                        </Slider>
                      </div>
                    </div>
                  </RespD>
                </React.Fragment>
              </>
            )
          })}
        </React.Fragment>
      </React.Fragment>
    )
  }

  renderContentCreationDialog = () =>
    <ContentCreationPlayer
      show={this.state.showContentCreationDialog}
      currentContentCreation={this.state.currentPlayingContent}
      handleClose={() => this.clearCurrentPlayingContent()}
      onNextArrow={this.state.hasNext ? () => this.setCurrentPlayingContent(this.state.currentIndex+1) : null}
      onPrevArrow={this.state.hasPrev ? () => this.setCurrentPlayingContent(this.state.currentIndex-1) : null}      
      // handleClose={() => this.setState({showContentCreationDialog: false,currentPlayingContent: {}})}
      isPublic={this.props.isPublic}
    />

  renderShareDialog = () =>
    <ShareOnSocials
      show={this.state.showShareDialog}
      handleClose={() => this.setState({showShareDialog: false})}
      url={this.state.shareLink}
      darkMode={true}
      shareToken={this.state.shareToken}
    />

  render = () => {
    if (this.state.failedLink) {
      return (
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          minHeight: "80vh",
          background: "white",
          width: "90%",
          borderRadius: "1%",
          margin: "0 5%",
          marginTop: "90px",
        }}>
          <p style={{fontSize: 30}}>{localization.get('error.expired_link')}</p>
        </div>)
    }

    if (this.state.loading) {
      return null
    } else {

      return (
        <div className={"playlist-inner"}>
          <div className={"playlist-container"} >
            {!this.props.isPublic &&
              <Link
                className={"playlist-back"}
                style={{
                  position: "absolute",
                  left: 30,
                  top: -32,
                  fontSize: 16,
                  fontWeight: "bold",
                  color: "white",
                  display: "flex",
                  alignItems: "center"
                }}
                to={homePathGenerator('mi-lista')}
              >
                <ArrowBack style={{width: 20, height: 20}}/>
                <span>{localization.get('playlist.back')}</span>
              </Link>
            }
          {this.state.playlist &&
          ((this.state.playlist.contentCreators && this.state.playlist.contentCreators.length > 0)
            || (this.state.playlist.contentCreations && this.state.playlist.contentCreations.length > 0 )) ?
              this.renderContentCreatorView() :
              <>
                <div className="playlist-title">
                  {this.state.playlist && this.state.playlist.title}
                  {!this.props.isPublic &&
                  <IconButton
                    style={{height: 30,marginLeft: 10,top: -3,width: 30}}
                    onClick={() => request.playlist.share(this.state.playlist.id)
                      .then(response => this.setState({
                        showShareDialog: true,
                        shareLink: `${window.location.protocol}//${window.location.hostname}/public/playlists/${response.code}`,
                        shareToken: response.code
                      }))}
                  >
                    <Tooltip placement="top" title={localization.get("share")} >
                      <Share style={{fontSize: 16}}/>
                    </Tooltip>
                  </IconButton>
                  }
                </div>
                <p style={{fontSize: 30, opacity: .8, textAlign: "center", padding: "10%", position: "relative", float: "left", width: "100%"}}>{localization.get('playlist.empty')}</p>
              </>
          }
          </div>
          {this.state.playlist && this.renderShareDialog()}
          {this.renderContentCreationDialog()}
        </div>
      )
    }
  }
}

export default Playlist;

const AudioBar = styled.audio`
@media (max-width: 440px) {
  width: 100%;
}
`;

const RespD = styled.div`
float: left;
position: relative;
padding: 5px 0px;
width: 100%;
@media (max-width: 460px) {
  padding: 8px;
}
`;

